import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "suggestFormattingRule",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" QuickSource detected that you've changed ")
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" to ")
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(". Would you like to create a custom Formatting Rule to automatically update this value going forward for the ")
const _hoisted_9 = { class: "fw-bold" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" field? ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "You can update, delete and create new rules at anytime by launching the Data Source Priority window and clicking the Formatting Rules tab.", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "checkbox",
      id: "suggestionSuppression",
      class: "me-1"
    }),
    /*#__PURE__*/_createTextVNode("Do not prompt me to automatically create rules for this field.")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ModalHeader, null, {
          default: _withCtx(() => [
            _createTextVNode("Create Formatting Rule for " + _toDisplayString(this.fieldFriendlyName), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_ModalBody, null, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, _toDisplayString(this.originalValue), 1),
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.newValue), 1),
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, _toDisplayString(this.fieldFriendlyName), 1),
              _hoisted_10
            ]),
            _hoisted_11,
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(_component_ModalFooter, null, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveAndViewFormattingRules && _ctx.saveAndViewFormattingRules(...args)))
            }, "Save & View Formatting Rules"),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, "Save"),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.skip && _ctx.skip(...args)))
            }, "Skip")
          ]),
          _: 1
        })
      ])
    ])
  ], 512))
}